import React from 'react'

import {
  Icon,
  BasicQuality,
  PremiumQuality,
  ProQuality,
  AIGenerated,
  Designer,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { QUALITY_LEVEL, CONTENT_SOURCE } from 'Pods/SearchPage/Store/constants'

const qualityFilters = [
  {
    value: QUALITY_LEVEL.ANY,
    label: 'Any',
  },
  {
    value: QUALITY_LEVEL.BASIC,
    label: 'Basic',
    icon: BasicQuality,
  },
  {
    value: QUALITY_LEVEL.PREMIUM,
    label: 'Premium',
    icon: PremiumQuality,
  },
  {
    value: QUALITY_LEVEL.PRO,
    label: 'Pro',
    icon: ProQuality,
  },
]

const contentSourceFilters = [
  {
    value: CONTENT_SOURCE.ALL,
    label: 'All Content',
  },
  {
    value: CONTENT_SOURCE.AI_GENERATED,
    label: 'AI Generated',
    icon: AIGenerated,
  },
  {
    value: CONTENT_SOURCE.HUMAN_CREATED,
    label: 'Human Created',
    icon: Designer,
  },
]

export const qualityFiltersConfig = [{
  label: 'QUALITY',
  tooltip:
    `<span>
      Basic - entry-level assets with simpler geometry and materials.<br/>
      Premium - higher fidelity assets with clean topology and detailed materials.<br/>
      Pro - top-tier assets built to professional standards and production use.<br/><br/>
      AI Generated - show only assets created with ai tools.<br/>
      Human Created - show only assets made by human designers.
    </span>`
  ,
  tooltipPlacement: 'bottom',
  tooltipContainerClassName: 'quality-filter__tooltip',
  filters: qualityFilters.map(filter => ({
    value: filter.value,
    label: filter.icon
      ? (
          <span className="filter-wrapper__option--with-icon">
            <Icon notSpaced svgComponent={filter.icon} color="primary" size="small" />
            <span>{filter.label}</span>
          </span>
        )
      : filter.label,
  })),
}]

export const contentSourceFiltersConfig = [{
  label: 'CONTENT SOURCE',
  filters: contentSourceFilters.map(filter => ({
    value: filter.value,
    label: filter.icon
      ? (
          <span className="filter-wrapper__option--with-icon">
            <Icon notSpaced svgComponent={filter.icon} color="primary" size="small" />
            <span>{filter.label}</span>
          </span>
        )
      : filter.label,
  })),
}]
